import { resolveSourceEntry, getFallbackTitle, getCliMovieTitle } from './PageMetaMappingPage'
import Translation from '../../Translation/cont/Translation'

const PageMetaMappingDetail = ({
    metaMoviePk,
    mapping,
    cinemas,
    providerMoviesProps,
    pmPreviewMovies,
    cliMovies,
    onSplit,
    onMove,
    onMerge,
    showSplitConfirm,
    onSplitConfirm,
    onCancelAction,
}) => {
    const sources = mapping.source || []
    const resolvedSources = sources.map(entry => resolveSourceEntry(entry, providerMoviesProps, cinemas)).filter(Boolean)
    const cliTitle = getCliMovieTitle(metaMoviePk, cliMovies)

    const providerName = resolvedSources.length > 0 ? resolvedSources[0].providerMovieKey : ''
    const sourceCount = resolvedSources.length
    const isMultiCinema = cinemas && Object.keys(cinemas).length > 1

    return (
        <div className="meta-mapping-detail">
            <div className="meta-mapping-detail-head">
                <div className="meta-mapping-detail-title">
                    {cliTitle || (resolvedSources[0] ? resolvedSources[0].title : getFallbackTitle(metaMoviePk, mapping, pmPreviewMovies))}
                </div>
                <div className="meta-mapping-detail-sub text-small-light">
                    {sourceCount} <Translation id={sourceCount !== 1 ? 'meta_mapping_ks_sources' : 'meta_mapping_ks_source'} />{providerName ? ` · ${providerName}` : ''}
                </div>
            </div>

            <div className="tmdb-link-section">
                <div className="tmdb-link-section-head">
                    <h3 className="tmdb-link-section-title text-small-bold"><Translation id="meta_mapping_ks_sources" /></h3>
                </div>
                <div className="tmdb-link-section-body meta-mapping-sources-body">
                    {resolvedSources.map((r, i) => (
                        <div key={i} className="meta-mapping-src-row">
                            <div className="meta-mapping-src-info">
                                <p className="meta-mapping-src-title text-small-regular">{r.title}</p>
                                {isMultiCinema && <span className="meta-mapping-src-cinema text-small-light">{r.cinemaShort}</span>}
                            </div>
                            <div className="meta-mapping-src-btns">
                                <button
                                    className="tmdb-link-btn text-small-regular"
                                    onClick={() => onMove(r.providerMovieKey, r.providerMovieUuid)}
                                >
                                    <Translation id="meta_mapping_move" />
                                </button>
                                {resolvedSources.length > 1 && (
                                    <button
                                        className="tmdb-link-btn text-small-regular"
                                        onClick={() => onSplit(r.providerMovieKey, r.providerMovieUuid)}
                                    >
                                        <Translation id="meta_mapping_split" />
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                    {resolvedSources.length === 0 && (
                        <div className="meta-mapping-src-empty text-small-light"><Translation id="meta_mapping_no_sources" /></div>
                    )}
                </div>
            </div>

            {showSplitConfirm && (
                <div className="meta-mapping-confirm-bar">
                    <span className="meta-mapping-confirm-text text-small-regular"><Translation id="meta_mapping_split_confirm" /></span>
                    <button className="tmdb-link-btn text-small-regular" onClick={onCancelAction}><Translation id="cancel_button" /></button>
                    <button className="tmdb-action-btn text-small-regular" onClick={onSplitConfirm}><Translation id="confirm_button" /></button>
                </div>
            )}

            <button
                className="meta-mapping-merge-btn text-small-regular"
                onClick={onMerge}
            >
                <Translation id="meta_mapping_merge_btn" />
            </button>
        </div>
    )
}

export default PageMetaMappingDetail
